import { render, staticRenderFns } from "./PersonInvoices.vue?vue&type=template&id=51089955&scoped=true&"
import script from "./PersonInvoices.vue?vue&type=script&lang=ts&"
export * from "./PersonInvoices.vue?vue&type=script&lang=ts&"
import style0 from "./PersonInvoices.vue?vue&type=style&index=0&id=51089955&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51089955",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
